import React from 'react';
import { motion } from 'framer-motion';
import {
  BookOpenIcon,
  ChartBarIcon,
  SparklesIcon,
  UserGroupIcon,
  BoltIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline';

const Slide03Solution: React.FC = () => {
  const features = [
    { icon: BookOpenIcon, label: 'Maths & English', sub: 'NSW Curriculum K-12' },
    { icon: ChartBarIcon, label: 'Live Knowledge Graph', sub: 'Visual mastery tracking' },
    { icon: SparklesIcon, label: 'AI Adaptation', sub: 'Personalised difficulty' },
    { icon: UserGroupIcon, label: 'Unified Experience', sub: 'Students, Teachers, Parents' },
    { icon: BoltIcon, label: 'Instant Feedback', sub: 'Every answer counted' },
    { icon: ShieldCheckIcon, label: 'Enterprise Security', sub: 'Australian data sovereignty' },
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full px-16">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-5xl font-bold text-white mb-4 text-center"
      >
        Introducing Lumen8
      </motion.h2>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-xl text-[#94a3b8] mb-12 text-center"
      >
        Real-time mastery tracking that transforms quarterly report cards into continuous insight
      </motion.p>

      <div className="grid grid-cols-3 gap-6">
        {features.map((item, index) => (
          <motion.div
            key={item.label}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4, delay: 0.3 + index * 0.08 }}
            className="flex items-center gap-4 px-5 py-4 rounded-xl"
            style={{
              background: 'rgba(30, 41, 59, 0.5)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
            }}
          >
            <div className="w-12 h-12 rounded-lg bg-[#0ea5e9]/20 flex items-center justify-center flex-shrink-0">
              <item.icon className="w-6 h-6 text-[#0ea5e9]" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-white">{item.label}</h3>
              <p className="text-sm text-[#64748b]">{item.sub}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Slide03Solution;
